import React from 'react'
import Modal from '~/Common-Objects/Modal/index'

export default function StatusGlossary({ close = () => {} }) {
    return (
        <Modal closeButton={true} blurBg={true} onCloseButton={close} width={560} closeButtonClass='topRightMore'>
            <div
                style={{
                    fontWeight: 600,
                    fontStyle: 'Semi Bold',
                    fontSize: '20px',
                    lineHeight: '24px',
                    letterSpacing: '-0.4px',
                    marginBottom: 12
                }}
            >
                Contact statuses in Transpond
            </div>
            <div
                style={{
                    fontWeight: 400,
                    fontStyle: 'Regular',
                    fontSize: '14px',
                    leadingTrim: 'NONE',
                    lineHeight: '20px',
                    letterSpacing: '0px',
                    marginBottom: 16
                }}
            >
                Statuses help you control who can receive your marketing emails. Only active contacts will receive email
                and SMS campaigns, and only Active contacts count toward your plans billable contacts.
            </div>

            <table className='glossary-table'>
                <tbody>
                    <tr>
                        <td>Active</td>
                        <td>
                            These contacts will receive campaigns when included in a Group or Segment. Active contacts
                            count toward billing on paid plans.
                        </td>
                    </tr>
                    <tr>
                        <td>In-Active</td>
                        <td>
                            Contacts you are keeping in Transpond but not sending campaigns to. These are often
                            unengaged contacts you want to retarget again in the future.
                        </td>
                    </tr>
                    <tr>
                        <td>Unsubscribed</td>
                        <td>
                            Will receive your campaigns when they are included in a group or segment. Active contacts
                            count toward billing.
                        </td>
                    </tr>
                    <tr>
                        <td>Bounced</td>
                        <td>
                            Their email address is not deliverable, or emails to them have failed repeatedly. They will
                            not get campaigns and do not count toward billing.
                        </td>
                    </tr>
                    <tr>
                        <td>Denylist</td>
                        <td>
                            Has unsubscribed from all groups or marked an email as spam. They will not get campaigns and
                            do not count toward billing.
                        </td>
                    </tr>
                </tbody>
            </table>

            <div
                style={{
                    fontWeight: 400,
                    fontStyle: 'Regular',
                    fontSize: '14px',
                    leadingTrim: 'NONE',
                    lineHeight: '20px',
                    letterSpacing: '0px',
                    marginTop: 16
                }}
            >
                A contact can be Active in one Group and Inactive or Unsubscribed in another. Bounced and Denylisted
                apply everywhere.
            </div>
        </Modal>
    )
}
